const LocalStorageKeys = {
  CLIENT_PORTAL_USER: "clientPortalUser",
  USER: "user"
};

export default LocalStorageKeys;
